module.exports = __webpack_public_path__ + "public/img/leo.b1c543ed.svg";